import { useEffect } from "react";

//adopted from: https://github.com/turingmachine/omxplayer-sync/blob/master/omxplayer-sync

// in seconds
const SYNC_TOLERANCE = .3;

// in milliseconds
const SYNC_GRACE_TIME = 200;

// in seconds
const SYNC_JUMP_AHEAD = .40;

export const USE_FASTSEEK = false;
const DEBUG = false;

export const useOtaSync = ({ playerRef, component: { syncSlug, syncStation }, playCallback }) => {
    const deviations = [];
    let lastSyncTime = Date.now();

    useEffect(() => {
        if ((!syncSlug && !syncStation) || typeof window === 'undefined' || !window.isIDANativeApp || !playerRef.current) {
            return;
        }

        const internalPlayer = playerRef.current?.getInternalPlayer();

        const cb = ({ detail: payload }) => {

            switch (payload.action) {
                case 'otaSyncTs':
                    console.debug('otaSyncTs', payload);

                    if (!internalPlayer) {
                        return;
                    }

                    if (internalPlayer.paused) {
                        internalPlayer.play();
                    }

                    internalPlayer.loop = true;

                    const { syncData } = payload;
                    const { stationId, slug, timestamp, timeData } = syncData;

                    const timestampS = (parseInt(timestamp)) / 1000;

                    const deviation = Math.abs(internalPlayer.currentTime - timestampS);
                    deviations.push(deviation);
                    if (deviations.length > 10) deviations.shift();

                    const medianDeviation = median(deviations);

                    if (DEBUG) {
                        console.log(medianDeviation);
                        console.log(lastSyncTime + SYNC_GRACE_TIME, Date.now());
                        console.log(timestampS); console.log(internalPlayer.currentTime);
                    }

                    if (lastSyncTime + SYNC_GRACE_TIME < Date.now() && medianDeviation > SYNC_TOLERANCE) {
                        const seekTo = timestampS + SYNC_JUMP_AHEAD;
                        DEBUG === true && console.log('seeking to ' + seekTo);
                        playCallback({stationId, slug, seekTo});
                        lastSyncTime = Date.now();
                    }

                    break;
                default:
                    break;
            }
        };

        document.addEventListener('onIDANative', cb);

        const nativeData = { action: 'requestOtaSync', syncSlug, syncStation };
        window.ReactNativeWebView.postMessage(JSON.stringify(nativeData));

        return () => {
            document.removeEventListener('onIDANative', cb);

            const nativeData = { action: 'requestOtaSync', syncSlug: null, syncStation: null };
            window.ReactNativeWebView.postMessage(JSON.stringify(nativeData));
        }

    }, [playerRef, syncSlug, syncStation]);
}

const median = arr => {
    const mid = Math.floor(arr.length / 2),
        nums = [...arr].sort((a, b) => a - b);
    return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
